export default "__VITE_ASSET__BSXX$3Gf__"